import { useEffect} from 'react'
import { useDispatch, useSelector } from '../../redux/store'
import { getNotificationPayment } from '../../api/payments'
import { setNotificationWithdraws } from '../../redux/slices/notification-withdraws'
import Label from '../label'

const NotificationWithdraws = ()=>{
    const {notificationWithdraws:notification } = useSelector((state)=> state.notificationWithdraws)
    const dispatch = useDispatch()

    useEffect(()=>{
        const fetchData = async()=>{
            const {paymentsNotification, success} = await getNotificationPayment()

            if(success){
                dispatch(setNotificationWithdraws(paymentsNotification))
            }else{
                dispatch(setNotificationWithdraws(0))
            }
        }
        fetchData()
    }, [dispatch])

    return notification ? <Label color="warning">+{notification}</Label> : ""
}


export default NotificationWithdraws